import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class EnqueteProvider {
  baseUrl = environment.API_URL;

  constructor(public http: HttpClient) { }

  getEnquetes() {
    return this.http.get<any>(this.baseUrl + '/enquete/get-enquetes')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getEnquete(idEnquete: any) {
    return this.http.post<any>(this.baseUrl + '/enquete/get-enquete', { idEnquete: idEnquete })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  iniciarEnquete(idEnquete: any) {
    return this.http.post<any>(this.baseUrl + '/enquete/iniciar-enquete', { idEnquete: idEnquete })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getProximaPergunta(idEnquete: any) {
    return this.http.post<any>(this.baseUrl + '/enquete/get-proxima-pergunta', { idEnquete: idEnquete })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  responderPergunta(resposta: any) {
    return this.http.post<any>(this.baseUrl + '/enquete/responder-pergunta', resposta)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  pularPergunta(resposta: any) {
    return this.http.post<any>(this.baseUrl + '/enquete/pular-pergunta', resposta)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  voltarPergunta(idEnquete: any) {
    return this.http.post<any>(this.baseUrl + '/enquete/voltar-pergunta', { idEnquete: idEnquete })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  resumoEnquete(idEnquete: any) {
    return this.http.post<any>(this.baseUrl + '/enquete/resumo-enquete', { idEnquete: idEnquete })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

}
